import { Link } from "react-router-dom";
import { ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";

const ForbiddenPage = () => (
  <div className="min-h-screen bg-background flex items-center justify-center p-6">
    <div className="max-w-md text-center">
      <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
        <ShieldX className="w-8 h-8 text-destructive" />
      </div>
      <h1 className="text-2xl font-bold text-foreground mb-2">Forbidden</h1>
      <p className="text-muted-foreground mb-6">
        You don't have permission to access this page. Contact your administrator if you believe this is an error.
      </p>
      <Link to="/">
        <Button className="bg-brand-forest hover:bg-brand-green-dk text-primary-foreground">
          Back to Home
        </Button>
      </Link>
    </div>
  </div>
);

export default ForbiddenPage;
